import _keyBy from 'lodash/keyBy';

const PREFIX = '@@resourcerizer';

export const actionTypes = {
  INITIALIZE: `${PREFIX}/INITIALIZE`,
  INSERT: `${PREFIX}/INSERT`,
  UPDATE_ONE: `${PREFIX}/UPDATE_ONE`,
  SELECT_ONE: `${PREFIX}/SELECT_ONE`
};

const INITIAL_STATE = {};

export const reducer = (state = INITIAL_STATE, action) => {
  const {type, payload, namespace} = action;

  switch (type) {
  case actionTypes.INITIALIZE: {
    const resourcer = {...state[namespace], isUpdating: true};
    return {...state, [namespace]: resourcer};
  }
  case actionTypes.INSERT: {
    const resourcer = {
      ...state[namespace],
      byId: _keyBy(payload.all, '_id'),
      isInitialized: true,
      isUpdating: false
    };

    return {...state, [namespace]: resourcer};
  }

  case actionTypes.UPDATE_ONE: {
    const { payload: { id, data } } = action;
    const resourcer = {
      ...state[namespace],
      byId: {...state[namespace].byId, [id]: {...state[namespace].byId[id], ...data}},
    };
    return {...state, [namespace]: resourcer};
  }


  case actionTypes.SELECT_ONE: {
    const resourcer = {...state[namespace], selectedId: payload.id};
    return {...state, [namespace]: resourcer};
  }

  default:
    return state;
  }
};

export const actionCreators = namespace => ({
  initialize: () => ({
    namespace,
    type: actionTypes.INITIALIZE
  }),

  insert: all => ({
    namespace,
    type: actionTypes.INSERT,
    payload: {all}
  }),

  selectOne: id => ({
    namespace,
    type: actionTypes.SELECT_ONE,
    payload: {id}
  }),

  updateOne: (id, data) => ({
    namespace,
    type: actionTypes.UPDATE_ONE,
    payload: {id, data}
  })
});

export const selectors = namespace => ({
  isInitialized: state => (state.resourcerizer[namespace] || {}).isInitialized,
  isUpdating: state => (state.resourcerizer[namespace] || {}).isUpdating,
  findOne: (state,predicate) => {
    const resourcer = state.resourcerizer[namespace]
    return resourcer && resourcer.byId && Object.values(resourcer.byId).find(predicate)
  },
  findAll: (state,predicate) => {
    const resourcer = state.resourcerizer[namespace]
    return resourcer && resourcer.byId ? Object.values(resourcer.byId).filter(predicate) : []
  },
  findOneById: (state,id) => {
    const resourcer = state.resourcerizer[namespace]
    return resourcer && resourcer.byId && resourcer.byId[id]
  },
  all: state => {
    const resourcer = state.resourcerizer[namespace]
    return resourcer && resourcer.byId ? Object.values(resourcer.byId) : []
  },
  selected: state => {
    const resourcer = state.resourcerizer[namespace]
    return resourcer && resourcer.byId && resourcer.selectedId && resourcer.byId[resourcer.selectedId]
  }
});


export const boundSelectors = namespace => state => {
  const resourcer = state.resourcerizer[namespace];
  return {
    isInitialized: resourcer && resourcer.isInitialized,
    isUpdating: resourcer && resourcer.isUpdating,
    all: resourcer && resourcer.byId ? Object.values(resourcer.byId) : [],
    selected:
      resourcer &&
      resourcer.byId &&
      resourcer.selectedId &&
      resourcer.byId[resourcer.selectedId]
  };
};

export const boundActions = namespace => dispatch => {
  //currified dispatch mapping
  const {initialize, selectOne, updateOne} = actionCreators(namespace);
  return {
    initialize: () => dispatch(initialize()),
    selectOne: id => () => dispatch(selectOne(id)),
    updateOne: (id,data) => () => dispatch(updateOne(id,data))
  };
};

import React, {Component} from 'react';
import {connect} from 'react-redux';

export const initializer = namespace => WrappedComponent => {

  const mstp = state => ({isInitialized: selectors(namespace).isInitialized(state)});
  const mdtp = dispatch => ({initialize: () => dispatch(actionCreators(namespace).initialize())});

  @connect(mstp, mdtp)
  class InitializerComponent extends Component {
    componentWillMount() {
      const {isInitialized, initialize} = this.props;
      if (!isInitialized) {
        initialize();
      }
    }

    render() {
      const {isInitialized} = this.props;
      if (isInitialized) {
        return <WrappedComponent {...this.props} />;
      }else{
        return <div>Loading...</div>
      }
    }
  }

  return InitializerComponent;
};

export const connector = namespace => WrappedComponent => {
  const mstp = boundSelectors(namespace);
  const mdtp = boundActions(namespace);
  return connect(mstp, mdtp)(WrappedComponent)
};

export const resource = namespace => WrappedComponent => {
  return initializer(namespace)(connector(namespace)(WrappedComponent))
}

export default {reducer, actionCreators, selectors, actionTypes, resource, connector, initializer};



// WEBPACK FOOTER //
// ./src/utils/resourcerizer.js